import { ISSUE_CATEGORY } from '../resources/endPoint';
import { serviceName } from '../resources/serviceConstants';

const issueCategory = (method, url, payload) => ({
  url,
  method,
  headers: { 'content-type': 'application/json' },
  authRequired: false,
  csrfToken: true,
  ...(payload ? { payload } : {}),
  service: serviceName.MASTER_MS,
});

export const getIssueCategory = () => issueCategory(
  'get',
  `${ISSUE_CATEGORY}?cb=${Date.now()}`,
);

export const createIssueCategory = (issueCategoryName) => issueCategory(
  'post',
  ISSUE_CATEGORY,
  {
    issueCategoryName: issueCategoryName,
  },
);

export const updateIssueCategory = (
  issueCategoryId,
  issueCategoryName,
  isActive,
) => issueCategory(
  'put',
  `${ISSUE_CATEGORY}/${issueCategoryId}`,
  {
    issueCategoryName: issueCategoryName,
    isActive: isActive,
  },
);
